/** Carimbos — cliente. Derivado no servidor das atividades concluídas com lugar. */
import { useQuery } from '@tanstack/react-query';

export interface Carimbo {
  activityId: string;
  dayId: string;
  date: string;
  title: string;
  place: string;
  latitude: number | null;
  longitude: number | null;
  with: string[];
  everyone: boolean;
}

export interface Passaporte {
  stamps: Carimbo[];
  places: number;
  days: number;
}

export function usePassaporte(tripId: string, ligado = true) {
  return useQuery({
    queryKey: ['passaporte', tripId],
    queryFn: async () => {
      const res = await fetch(`/api/v1/trips/${tripId}/passport`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`Falha (${res.status})`);
      return (await res.json()) as Passaporte;
    },
    enabled: ligado,
    staleTime: 30_000,
  });
}
